/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumItem5 } from './EnumItem5';
import {
    EnumItem5FromJSON,
    EnumItem5FromJSONTyped,
    EnumItem5ToJSON,
    EnumItem5ToJSONTyped,
} from './EnumItem5';

/**
 * 
 * @export
 * @interface ResponseListEnumItem
 */
export interface ResponseListEnumItem {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListEnumItem
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListEnumItem
     */
    message?: string;
    /**
     * 
     * @type {Array<EnumItem5>}
     * @memberof ResponseListEnumItem
     */
    data?: Array<EnumItem5>;
}

/**
 * Check if a given object implements the ResponseListEnumItem interface.
 */
export function instanceOfResponseListEnumItem(value: object): value is ResponseListEnumItem {
    return true;
}

export function ResponseListEnumItemFromJSON(json: any): ResponseListEnumItem {
    return ResponseListEnumItemFromJSONTyped(json, false);
}

export function ResponseListEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EnumItem5FromJSON)),
    };
}

export function ResponseListEnumItemToJSON(json: any): ResponseListEnumItem {
    return ResponseListEnumItemToJSONTyped(json, false);
}

export function ResponseListEnumItemToJSONTyped(value?: ResponseListEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EnumItem5ToJSON)),
    };
}

